import React from "react";
import Letop from "../allpages/Letop";

export default () => (
  <div>
    <div className="table">
      <table>
        <tr>
          <th className="col" />
          <th colSpan={2}>comparativus</th>
        </tr>
        <tr>
          <th className="col bor-bot" />
          <th>mnl/vrl</th>
          <th>onzijdig</th>
        </tr>
        <tr>
          <th className="col">nom. ev.</th>
          <td>longior</td>
          <td>
            long
            <strong>ius</strong>
          </td>
        </tr>
        <tr>
          <th className="col">gen. ev.</th>
          <td>
            longior–
            <strong>is</strong>
          </td>
          <td>
            longior–
            <strong>is</strong>
          </td>
        </tr>
        <tr>
          <th className="col">dat. ev.</th>
          <td>
            longior–
            <strong>i</strong>
          </td>
          <td>
            longior–
            <strong>i</strong>
          </td>
        </tr>
        <tr>
          <th className="col">acc. ev.</th>
          <td>
            longior–
            <strong>em</strong>
          </td>
          <td>
            long
            <strong>ius</strong>
          </td>
        </tr>
        <tr>
          <th className="col bor-bot">abl. ev.</th>
          <td className="bor-bot">
            longior–
            <strong>e</strong>
          </td>
          <td className="bor-bot">
            longior–
            <strong>e</strong>
          </td>
        </tr>
        <tr>
          <th className="col">nom. mv.</th>
          <td>
            longior–
            <strong>es</strong>
          </td>
          <td>
            longior–
            <strong>a</strong>
          </td>
        </tr>
        <tr>
          <th className="col">gen. mv.</th>
          <td>
            longior–
            <strong>um</strong>
          </td>
          <td>
            longior–
            <strong>um</strong>
          </td>
        </tr>
        <tr>
          <th className="col">dat. mv.</th>
          <td>
            longior–
            <strong>ibus</strong>
          </td>
          <td>
            longior–
            <strong>ibus</strong>
          </td>
        </tr>
        <tr>
          <th className="col">acc. mv.</th>
          <td>
            longior–
            <strong>es</strong>
          </td>
          <td>
            longior–
            <strong>a</strong>
          </td>
        </tr>
        <tr>
          <th className="col">abl. mv.</th>
          <td>
            longior–
            <strong>ibus</strong>
          </td>
          <td>
            longior–
            <strong>ibus</strong>
          </td>
        </tr>
      </table>
    </div>

    <p>
      <Letop>
        Het rijtje van de comparativus gaat hetzelfde als de rijtjes van{" "}
        <a href="zelfstandig-naamwoord">
          <strong>rex</strong> en <strong>nomen</strong>
        </a>
        , met één onregelmatigheid: <strong>-ior</strong> wordt bij het onzijdig
        nom./acc. enkelvoud vervangen door <strong>-ius</strong>.
      </Letop>
    </p>

    <div className="table">
      <table>
        <tr>
          <th className="col" />
          <th colSpan={3}>superlativus</th>
        </tr>
        <tr>
          <th className="col bor-bot" />
          <th>mannelijk</th>
          <th>vrouwelijk</th>
          <th>onzijdig</th>
        </tr>
        <tr>
          <th className="col">nom. ev.</th>
          <td>
            longissim–
            <strong>us</strong>
          </td>
          <td>
            longissim–
            <strong>a</strong>
          </td>
          <td>
            longissim–
            <strong>um</strong>
          </td>
        </tr>
        <tr>
          <th className="col">gen. ev.</th>
          <td>
            longissim–
            <strong>i</strong>
          </td>
          <td>
            longissim–
            <strong>ae</strong>
          </td>
          <td>
            longissim–
            <strong>i</strong>
          </td>
        </tr>
        <tr>
          <th className="col">dat. ev.</th>
          <td>
            longissim–
            <strong>o</strong>
          </td>
          <td>
            longissim–
            <strong>ae</strong>
          </td>
          <td>
            longissim–
            <strong>o</strong>
          </td>
        </tr>
        <tr>
          <th className="col">acc. ev.</th>
          <td>
            longissim–
            <strong>um</strong>
          </td>
          <td>
            longissim–
            <strong>am</strong>
          </td>
          <td>
            longissim–
            <strong>um</strong>
          </td>
        </tr>
        <tr>
          <th className="col bor-bot">abl. ev.</th>
          <td className="bor-bot">
            longissim–
            <strong>o</strong>
          </td>
          <td className="bor-bot">
            longissim–
            <strong>a</strong>
          </td>
          <td className="bor-bot">
            longissim–
            <strong>o</strong>
          </td>
        </tr>
        <tr>
          <th className="col">nom. mv.</th>
          <td>
            longissim–
            <strong>i</strong>
          </td>
          <td>
            longissim–
            <strong>ae</strong>
          </td>
          <td>
            longissim–
            <strong>a</strong>
          </td>
        </tr>
        <tr>
          <th className="col">gen. mv.</th>
          <td>
            longissim–
            <strong>orum</strong>
          </td>
          <td>
            longissim–
            <strong>arum</strong>
          </td>
          <td>
            longissim–
            <strong>orum</strong>
          </td>
        </tr>
        <tr>
          <th className="col">dat. mv.</th>
          <td>
            longissim–
            <strong>is</strong>
          </td>
          <td>
            longissim–
            <strong>is</strong>
          </td>
          <td>
            longissim–
            <strong>is</strong>
          </td>
        </tr>
        <tr>
          <th className="col">acc. mv.</th>
          <td>
            longissim–
            <strong>os</strong>
          </td>
          <td>
            longissim–
            <strong>as</strong>
          </td>
          <td>
            longissim–
            <strong>a</strong>
          </td>
        </tr>
        <tr>
          <th className="col">abl. mv.</th>
          <td>
            longissim–
            <strong>is</strong>
          </td>
          <td>
            longissim–
            <strong>is</strong>
          </td>
          <td>
            longissim–
            <strong>is</strong>
          </td>
        </tr>
      </table>
    </div>

    <p>
      <Letop>
        Het rijtje van de superlativus gaat in feite hetzelfde als de rijtjes
        van{" "}
        <a href="zelfstandig-naamwoord">
          <strong>servus</strong>, <strong>femina</strong> en{" "}
          <strong>donum</strong>
        </a>
        .
      </Letop>
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/tables/comp-super.js